import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onBeforeMount, watch } from 'vue';
import { useHead } from '@unhead/vue';
import { useUserStore } from '@/store/user.store';
import { useI18n } from 'vue-i18n';
import { initCrispChat } from '@/constants/crisp';
import Intercom from '@intercom/messenger-js-sdk';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'InitWrapper',
  setup(__props) {
    const {
      t
    } = useI18n();
    const userStore = useUserStore();
    // предзаданные параметры страницы
    useHead({
      title: t('page-title'),
      meta: [{
        name: 'description',
        content: t('page-description')
      }]
    });
    const {
      isModerator
    } = storeToRefs(userStore);
    onBeforeMount(async () => {
      userStore.setUserDetailsLoading(true);
      await userStore.checkUserLoggedIn();
      userStore.setUserDetailsLoading(false);
    });
    watch(() => userStore.userDetails && isModerator.value, value => {
      const user = userStore.userDetails;
      if (value && user) {
        initCrispChat();
        Intercom({
          app_id: 'oz7e61bk',
          user_id: user.id,
          name: user.name,
          email: user.email,
          created_at: 0
        });
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_RouterView = _resolveComponent("RouterView");
      return _openBlock(), _createBlock(_component_RouterView);
    };
  }
});